export default "__VITE_ASSET__BnyaZvdB__"